import { AxiosRequestConfig } from 'axios';
import { get } from 'lodash';
import { useCreateQuery, QueryOptions } from '../../CRUD';
import { axiosService } from '../../services/axiosService';
import { broadcastBaseModel } from './crud';

export const useFetchBroadcastsSuccessReport = (
  params?: AxiosRequestConfig['params'],
  options?: QueryOptions<AxiosRequestConfig['params']>,
) => {
  const { keys } = broadcastBaseModel;

  const broadcastId = get(params, 'id', '');

  async function queryFn() {
    const { data } = await axiosService.get(
      `${keys.basicUrlPath}/${broadcastId}/successReport`,
    );

    return data;
  }

  return useCreateQuery<number>(keys.many(params), queryFn, params, options);
};
